import React from 'react';
import { CommonDeleteModal } from 'components/common';
import { useDeleteModal } from './useDeleteModal';

interface IDeleteModal {
  openModal: boolean;
  dataToDelete: { id: string | undefined };
  onDeleteModalClose: () => void;
}

export const DeleteModal = (props: IDeleteModal) => {
  const { openModal, onDeleteModalClose, dataToDelete } = props;
  const { onRemoveConfirm, contextHolder, isLoading } = useDeleteModal(onDeleteModalClose);
  return (
    <>
      {contextHolder}
      <CommonDeleteModal
        onCancel={onDeleteModalClose}
        open={openModal}
        isLoading={isLoading}
        onOk={() => onRemoveConfirm(dataToDelete)}
        onClose={onDeleteModalClose}
        title={'Delete City Shipping Rate'}
        message={'Are you sure you want to delete the City Shipping Rate?'}
      />
    </>
  );
};
